// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + {"build_node_index_js":"2a33a34c7deadea6bce54038e7419ba43b51c2d9702d9a8cdcee0102cab72b53","node_modules_react_index_js":"7d7485f470234010ac1ac35604536f8ddc0956bd2335506d15e1168db6893246"}[chunkId] + ".js";
};